<template>
  <ul id="platList">
    <li
      v-for="(item, index) in iotCarList"
      :key="index"
      @click="changePlat(item)"
    >
      {{ item.simNo }}
    </li>
  </ul>
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
      iotCarList:[]
    };
  },
  methods: {
    getPlatform() {
      axios({
        method: "post",
        url:  axios.dm +"/iotCard/list",
        data: {},
      }).then((res) => {

        var data = res.data.data.dataList;
        console.log(data);
        this.iotCarList=data.filter(item => item.useState==0);
      });
    },
    changePlat(v) {
      this.$emit('iotCard',v)
    },
  },
  mounted() {
    this.getPlatform();
  },
};
</script>
<style>
#platList li {
  padding: 10px;
}
#platList li:hover {
  background: #d2eefd;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/information/iotCardList.vue